import { TMenuIds } from "../../../../app/state/menuSlice/types";
import { MenuBasic } from "../../../Components/Menu/MenuBasic";
import { useMenuSelectors } from "../../../../app/state/menuSlice/hook/use-menu-selectors";
import { AppMenuItem } from "../../../../shared/components/AppMenu/AppMenuItem";
import { ObjectIcon } from "../../../../shared/icons/ObjectIcon";
import { FolderIcon } from "../../../../shared/icons/FolderIcon";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";
import { getServiceObjectName } from "../../helpers/getServiceObjectName";
import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";

interface Props {
  closeMenu: (id: TMenuIds) => void;
  service: StorageScope;
  onAddObject?: () => void;
  handleOpenAddFolderModal?: () => void;
}

export const AddStorageObjectMenu = ({
  closeMenu,
  service,
  onAddObject,
  handleOpenAddFolderModal,
}: Props) => {
  const addStorageObjectMenu = useMenuSelectors("add_storage_object_menu");
  const { t } = useTranslation();

  const handleAddStorageObject = (type: "folder" | "object") => {
    if (type === "folder") {
      handleOpenAddFolderModal && handleOpenAddFolderModal();
      closeMenu("add_storage_object_menu");
    } else {
      onAddObject && onAddObject();
    }
  };

  return (
    <MenuBasic
      disablePortal
      slotProps={{
        paper: {
          onMouseLeave: () => closeMenu("add_storage_object_menu"),
        },
      }}
      isOpen={addStorageObjectMenu.isOpen}
      position={addStorageObjectMenu.position}
      onClose={() => closeMenu("add_storage_object_menu")}
      anchorPosition={{
        left: addStorageObjectMenu.position?.x ?? 0,
        top: (addStorageObjectMenu.position?.y ?? 0) + 35,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <AppMenuItem
        onClick={() => handleAddStorageObject("object")}
        className={styles["menu-item"]}
      >
        <ObjectIcon />
        {t(`${getServiceObjectName(service)}`)}
      </AppMenuItem>
      <AppMenuItem
        onClick={() => handleAddStorageObject("folder")}
        className={styles["menu-item"]}
      >
        <FolderIcon />
        Добавить папку
      </AppMenuItem>
    </MenuBasic>
  );
};
